import { configureStore } from '@reduxjs/toolkit';
import { logger } from '@tecma/logs-fe';
import createSagaMiddleware from 'redux-saga';

import { combinedReducers } from './reducers';
import rootSaga from './sagas';
import { applicationStateActions } from './slices/applicationState/slice';

export type CombinedReducersType = ReturnType<typeof combinedReducers>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = CombinedReducersType;

export const storeFactory = (preloadedState: Partial<RootState> = {}) => {
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: combinedReducers,
    devTools: true,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
    preloadedState,
  });
  sagaMiddleware
    .run(rootSaga)
    .toPromise()
    .catch((error) => {
      logger.error(error);
      store.dispatch(applicationStateActions.setError());
    });

  return store;
};
